import { render, staticRenderFns } from "./ErrorNoFound.vue?vue&type=template&id=33412705&"
import script from "./ErrorNoFound.vue?vue&type=script&lang=js&"
export * from "./ErrorNoFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports